<script>
export default {
  props: {
    modelValue: Boolean,
    list: {
      type: Array,
      default: () => [],
    },
    saving: {
      type: Boolean,
      default: false,
    },
  },
  emits: ["update:modelValue", "confirm"],
  methods: {
    closeModal() {
      this.$emit("update:modelValue", false);
    },
    onConfirm() {
      this.$emit("confirm");
    },
  },
};
</script>

<template>
  <b-modal
    :model-value="modelValue"
    @hide="closeModal"
    centered
    hide-footer
    title="Konfirmasi Pemilihan Kompetensi"
    dialog-class="modal-lg"
  >
    <div class="mb-3">
      Anda akan memakai <strong>{{ list.length }}</strong> kompetensi berikut:
    </div>

    <div v-if="list.length === 0" class="alert alert-info fw-bold">
      <i class="fa fa-info-circle text-primary me-1"></i>
      Belum ada kompetensi yang dipilih.
    </div>

    <ul
      v-else
      class="list-group mb-3"
      style="max-height: 400px; overflow-y: auto"
    >
      <li
        v-for="item in list"
        :key="item.idkompetensi"
        class="list-group-item d-flex justify-content-between align-items-start"
      >
        <div>
          <div class="fw-bold">{{ item.nama_kompetensi }}</div>
          <div class="small text-muted">
            {{ item.kode_kompetensi }} &middot; Level: {{ item.level_kompetensi }}
          </div>
        </div>
        <span v-if="item.terpilih_otomatis" class="badge bg-secondary">
          Otomatis
        </span>
      </li>
    </ul>

    <div class="text-end">
      <button
        type="button"
        class="btn btn-secondary me-2"
        :disabled="saving"
        @click="closeModal"
      >
        Batal
      </button>
      <button
        type="button"
        class="btn btn-primary"
        :disabled="saving || list.length === 0"
        @click="onConfirm"
      >
        <i class="fas fa-spinner fa-spin me-1" v-if="saving"></i>
        Ya, Simpan
      </button>
    </div>
  </b-modal>
</template>
